import axios from 'axios';

// agents code
export async function fetchAgentCodeAPI() {
	let agentcode = [];
	
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}agents/agentcode`,
			// data: Data,
			// headers: { 
			// 	'content-type': 'application/json',
			// }
		});

		const { data } = response;
		agentcode = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return agentcode;
}

// search agents api
export async function searchAgentsAPI(payload) {
	const AgentCode = payload.agent_code === undefined ? '' : payload.agent_code;
	const LastName = payload.last_name === undefined ? '' : payload.last_name;
	const FirstName = payload.first_name === undefined? '' : payload.first_name;
	const Status = payload.status === undefined? '' : payload.status;
	let agentslist = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}agents/search/?agent_code=${AgentCode}&last_name=${LastName}&first_name=${FirstName}&status=${Status}`,
			data: payload,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		agentslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return agentslist;
}

//create agents api
export async function createAgentAPI(Data) {
	let agentData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}agents/create/`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		agentData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return agentData;
}

//update agents api
export async function updateAgentAPI(Data) {
	let agentData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}agents/update/`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		agentData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return agentData;
}